// extracted by mini-css-extract-plugin
export default {"root":"CopyText_root__l5EGG","input":"CopyText_input__-5OwP","button":"CopyText_button__cn2CD","adaptive":"CopyText_adaptive__ZpPGV"};